import analytics from '../../shared/services/analytics/analytics';
import { AppDispatch, GetState } from '../../shared/services/store';

// docs on event https://wiki.worldquant.com/display/BRAIN/List+of+Google+analytics+events
export const trackSignUpField = (fieldDataOrEvent: any) => (dispatch: AppDispatch, getState: GetState) => {
  const state = getState();
  const fields = (state.getIn(['account', 'dataFields']) as any).toJS();
  const name = fieldDataOrEvent?.currentTarget?.name || fieldDataOrEvent?.name;

  const isTextInput = fieldDataOrEvent?.type === 'blur' && !!fieldDataOrEvent?.target?.value;
  const isSelect = fieldDataOrEvent?.options;
  const isRadio = typeof fieldDataOrEvent?.value === 'boolean';
  const isCaptcha = fieldDataOrEvent?.name === 'captcha' && !!fieldDataOrEvent?.value;
  const isCheckbox = typeof fieldDataOrEvent?.checked === 'boolean';

  if (isTextInput || isSelect || isRadio || isCaptcha || isCheckbox) {
    // if field has errors, send only error analytics
    if (fields?.[name]?.errors?.length) {
      return analytics.trackCustomEvent('sign_up_field_error', { event_label: name });
    }

    analytics.trackCustomEventOnce('sign_up_field_complete', { event_label: name });

    let value;

    if (isRadio) {
      value = fieldDataOrEvent?.value;
    } else if (isCheckbox) {
      value = fieldDataOrEvent?.checked;
    }

    if (typeof value !== 'undefined') {
      const valueFormatted = value ? 'true' : 'false';
      analytics.trackCustomEvent('sign_up_field_complete', { event_label: `${name}_${valueFormatted}` });
    }
  }
};
